<script>
import Footer from "./Footer";
import Filter from "./Filter";
import NoContent from "./NoContent";
import Loading from "@/components/Loading";
import Header from "./Header";

import BasicButton from "@/components/basic/Button";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import _size from "lodash/size";
import _isUndefined from "lodash/isUndefined";

export default {
  props: {
    client: {
      required: true,
      type: Function,
    },
    defaultFilter: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: true,
      items: [],
      meta: null,
      filter: this.defaultFilter,
    };
  },

  computed: {
    hasActiveFilter() {
      return _size(this.filter) > 0;
    },
    hasItems() {
      return this.items.length > 0;
    },
    showHeader() {
      return (
        !_isUndefined(this.$slots.filter) && !_isUndefined(this.$slots.actions)
      );
    },
    showFooter() {
      return !!this.meta;
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    load(page = 1) {
      this.loading = true;

      let resolve = (data) => {
        this.items = data.data;
        this.meta = data.meta;

        this.loading = false;
      };

      this.client({
        page,
        resolve,
        filter: this.filter,
      });
    },

    next() {
      this.load(this.meta.current_page + 1);
    },

    previous() {
      this.load(this.meta.current_page - 1);
    },
  },

  render(h) {
    const filter = h(
      Filter,
      {
        props: {
          filter: this.filter,
        },
        on: {
          input: (filter) => {
            this.filter = filter;
            this.load();
          },
        },
      },
      this.$slots.filter
    );

    const header = h(Header, [
      _isUndefined(this.$slots.filter) ? h("div") : filter,
      h("div", this.$slots.actions),
    ]);

    const table = h("div", [
      h("div", this.$slots.header),
      h(
        "div",
        {
          class: ["grid grid-flow-row text-sm"],
        },
        this.items.map((item) => {
          return h(
            "div",
            this.$scopedSlots.table({
              item: item,
            })
          );
        })
      ),
    ]);

    const footer = h(Footer, {
      props: {
        meta: this.meta,
      },
      on: {
        next: () => this.next(),
        previous: () => this.previous(),
      },
    });

    const contentState = [
      this.showHeader ? header : h("span"),
      this.hasItems ? table : h(NoContent),
      this.showFooter && this.hasItems ? footer : h("span"),
    ];

    const loadingState = [h(Loading, { class: "min-h-128" })];

    return h(
      "div",
      { class: ["w-full shadow rounded"] },
      this.loading ? loadingState : contentState
    );
  },
};
</script>